import Fuse from 'fuse.js';
import { getPhoneNumber } from './clientUtils';

export const createSearchIndex = (clients) => {
  // Prepare clients with formatted phone numbers for searching
  const clientsWithFormattedPhones = clients.map(client => ({
    ...client,
    full_name: `${client.first_name} ${client.last_name}`,
    formatted_phone: getPhoneNumber(client)
  }));

  const options = {
    keys: [
      { name: 'full_name', weight: 0.3 },
      { name: 'formatted_phone', weight: 0.3 },
      { name: 'email', weight: 0.1 }
    ],
    threshold: 0.3,
    ignoreLocation: true,
    shouldSort: true
  };

  return new Fuse(clientsWithFormattedPhones, options);
};

export const searchClients = (fuse, query) => {
  if (!query.trim()) {
    return fuse.getIndex().docs; // Return all clients when no query
  }
  
  // Clean up phone number query to match format
  const cleanQuery = query.replace(/[^\d]/g, '');
  if (cleanQuery.length >= 6 && /^\d+$/.test(cleanQuery)) {
    // If query is mostly numbers, search with formatted version
    const formattedQuery = `(${cleanQuery.slice(0, 3)}) ${cleanQuery.slice(3, 6)}${cleanQuery.length > 6 ? '-' + cleanQuery.slice(6) : ''}`;
    const results = fuse.search(formattedQuery);
    if (results.length > 0) {
      return results.map(result => result.item);
    }
  }
  
  // If not a phone number or no results found, search with original query
  const results = fuse.search(query);
  return results.map(result => result.item);
};

export const applySorting = (data, sorting) => {
  if (!sorting) return data;
  return [...data].sort((a, b) => {
    const aValue = a[sorting.field];
    const bValue = b[sorting.field];
    return sorting.direction === 'asc' 
      ? (aValue > bValue ? 1 : -1)
      : (aValue < bValue ? 1 : -1);
  });
};

export const filterClients = (clients, {
  genderFilter,
  ageGroupFilter,
  getAge,
  getAgeGroup,
  isOptedInReminder,
  isOptedInMarketing
}) => {
  let results = clients;
  
  // Apply gender filter
  if (genderFilter) {
    results = results.filter(client => client.gender === genderFilter);
  }
  
  // Apply age filter
  if (ageGroupFilter) {
    results = results.filter(client => {
      const age = getAge(client.birthday);
      return getAgeGroup(age) === ageGroupFilter;
    });
  }

  // Apply opt-in filters
  if (isOptedInReminder) {
    results = results.filter(client => client.is_opted_in_reminder);
  }

  if (isOptedInMarketing) {
    results = results.filter(client => client.is_opted_in_marketing);
  }
  
  return results;
};

export const processClientData = ({
  clients,
  searchIndex,
  searchQuery,
  filters,
  sorting
}) => {
  let result = clients;

  // Apply search if query exists
  if (searchQuery) {
    result = searchClients(searchIndex, searchQuery);
  }

  // Apply filters
  if (filters) {
    result = filterClients(result, filters);
  }

  // Apply sorting
  return applySorting(result, sorting);
}; 